/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Tab_Seo1Inputs */

const vi_sitesettings_tab_seo1 = /** @type {(inputs: Sitesettings_Tab_Seo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO`)
};

/**

* @param {Sitesettings_Tab_Seo1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_tab_seo1 = /** @type {((inputs?: Sitesettings_Tab_Seo1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Tab_Seo1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_tab_seo1(inputs)
});
export { sitesettings_tab_seo1 as "siteSettings_tab_seo" }